var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#C2C2C2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xED\x94\x84\xEB\xA1\x9C\xEC\xA0\x9D\xED\x8A\xB8\xEC\x83\x81\xEC\x84\xB8_\xEC\x82\xB0\xEC\xB6\x9C\xEB\x82\xB4\xEC\x97\xAD\xEC\x84\x9C_\xEC\x83\x9D\xEC\x84\xB1\xED\x9B\x84_\xEB\x8D\xB0\xEC\x9D\xB4\xED\x84\xB0\xEC\x84\xA0\xED\x83\x9D"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2431,
    transform: "translate(-839 -820)",
    fill: "#F4F6F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB3\xB5\xEA\xB3\xA0\xEC\x83\x81\xEC\x84\xB8_\xEC\x82\xB0\xEC\xB6\x9C\xEB\x82\xB4\xEC\x97\xAD\xEC\x84\x9C_\xEC\x83\x9D\xEC\x84\xB1\xED\x9B\x84_\xEB\x8D\xB0\xEC\x9D\xB4\xED\x84\xB0\xEC\x84\xA0\xED\x83\x9D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 42"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_114_11107",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-487 -415H1022V606C1022 612.627 1016.63 618 1010 618H-475C-481.627 618 -487 612.627 -487 606V-415Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-487 -415H1022V606C1022 612.627 1016.63 618 1010 618H-475C-481.627 618 -487 612.627 -487 606V-415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-487 -415H1022H-487ZM1023 606C1023 613.18 1017.18 619 1010 619H-475C-482.18 619 -488 613.18 -488 606H-486C-486 612.075 -481.075 617 -475 617H1010C1016.08 617 1021 612.075 1021 606H1023ZM-475 619C-482.18 619 -488 613.18 -488 606V-415H-486V606C-486 612.075 -481.075 617 -475 617V619ZM1023 -415V606C1023 613.18 1017.18 619 1010 619V617C1016.08 617 1021 612.075 1021 606V-415H1023Z",
    fill: "#E1E3E5",
    mask: "url(#path-1-inside-1_114_11107)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Template (Detach me!)",
    filter: "url(#filter0_d_114_11107)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_11107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Columns"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Columns_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".Data Cells"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 451,
    height: 36,
    transform: "translate(-431 -14)",
    fill: "#F4F6F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Button",
    filter: "url(#filter1_d_114_11107)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: -4,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#56423E",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fa-solid:pen",
    clipPath: "url(#clip1_114_11107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.54298 1.45676L6.54329 3.45707L2.1997 7.80066L0.416263 7.99754C0.177513 8.02395 -0.0242053 7.82207 0.00235719 7.58332L0.200795 5.79863L4.54298 1.45676ZM7.78048 1.15895L6.84126 0.219727C6.54829 -0.0732422 6.07314 -0.0732422 5.78017 0.219727L4.89658 1.10332L6.89689 3.10363L7.78048 2.22004C8.07345 1.92691 8.07345 1.45191 7.78048 1.15895Z",
    fill: "white"
  }))))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_114_11107",
    x: -471,
    y: -306,
    width: 1477,
    height: 886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_114_11107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_114_11107",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_114_11107",
    x: -7,
    y: -6,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_114_11107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_114_11107",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_11107"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -467,
    y: -306,
    width: 1469,
    height: 878,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_114_11107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWhite);
export default __webpack_public_path__ + "static/media/pencil-white.111dc74c1a5ed0f601a7e12cdbc9be08.svg";
export { ForwardRef as ReactComponent };